export default __webpack_public_path__ + "static/media/flood.7ebd77d1.svg";